// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"acce51bc","821":"8f3aad65"}[chunkId] + ".chunk.js";
};